import { AxiosError, AxiosResponse } from 'axios'

import { axiosServer as axios } from '@/base/axios'

const MAX_RETRIES = 3
const INITIAL_DELAY = 1000

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const getPromiseFromFetch = <T = any>({
  params = {},
  config = {},
  method = 'get',
  url = ''
}) =>
  new Promise<AxiosResponse<T>>(async (resolve) => {
    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        const res = await (axios as any)[method](url, params, config)
        resolve(res)
        return
      } catch (error: unknown) {
        const axiosError = error as AxiosError

        // Non ritentare per errori client (4xx) eccetto 408 (Request Timeout) e 429 (Too Many Requests)
        const status = axiosError.response?.status
        if (
          status &&
          status >= 400 &&
          status < 500 &&
          status !== 408 &&
          status !== 429
        ) {
          resolve(axiosError.response as AxiosResponse)
          return
        }

        // Se abbiamo esaurito i tentativi, restituisci l'errore
        if (attempt === MAX_RETRIES) {
          resolve(axiosError.response as AxiosResponse)
          return
        }

        // Backoff esponenziale: 1s, 2s, 4s
        await delay(INITIAL_DELAY * Math.pow(2, attempt))
      }
    }
  })
